'use client';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

export function ImpressumContent() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-5 lg:gap-7.5">
      <Card>
        <CardHeader>
          <CardTitle as="h1">{t('pages.region.imprint.title')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <p className="text-sm text-foreground">
              Firmendata UG (haftungsbeschränkt)
              <br />
              c/o Ersin Bayraktar
              <br />
              Pistoriusstraße 102A
              <br />
              13086 Berlin DE
            </p>
          </div>

          <div>
            <p className="text-sm text-foreground">
              E-mail: info@firmendata.com
            </p>
          </div>

          <div>
            <p className="text-sm text-foreground">
              {t('pages.region.imprint.representatives')}<br />
              Julian Lenz <br />
              Ersin Bayraktar
            </p>

            <p className="text-sm text-foreground">
              <br />
              {t('pages.region.imprint.responsible')}
              <br />
              Julian Lenz {t('pages.region.imprint.responsibleNote')}
            </p>
          </div>

          <div>
            <p className="text-sm text-foreground">{t('pages.region.imprint.register')}</p>
            <p className="text-sm text-foreground">{t('pages.region.imprint.vatId')}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
